/* eslint-disable formatjs/no-literal-string-in-jsx */
import { createRender } from './types';

export const render = createRender(() => <button>{`Hello world!`}</button>);

export default render;
